// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PHeartOutlinedSvg from "@fishx/icons-svg/es/asn/PHeartOutlined";
import FishxIcon from '../components/FishxIcon';

var PHeartOutlined = function PHeartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PHeartOutlinedSvg
  }));
};

PHeartOutlined.displayName = 'PHeartOutlined';
export default React.forwardRef(PHeartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PHeartOutlined.js
// module id = 3448
// module chunks = 0